<template>
  <DsDocumentationSection
    title="Lo que necesitarás durante tu proceso"
    title-id="release-documentation-title"
    description="Tu camino está dividido en etapas claras. Aquí puedes entender en cuál estás y qué sigue:"
    :image="documentationImage"
    :mobile-image="documentationMobileImage"
    image-alt="Propietario consultando su teléfono"
    :items="items"
    media-position="end"
    media-last-mobile
  >
    <template #after-items
      ><p class="release-documentation-note">
        Mantente atento a tu correo electrónico registrado, donde recibirás la carta.
      </p></template
    >
  </DsDocumentationSection>
</template>
<script setup lang="ts">
import DsDocumentationSection from '../components/DsDocumentationSection.vue'
import documentationImage from '../../../assets/liberacion/documentacion.png'
import documentationMobileImage from '../../../assets/liberacion/documentacion-mobile.png'
import quoteIcon from '../../../assets/liberacion/icon-cotizacion.svg'
import quoteMobileIcon from '../../../assets/liberacion/icon-cotizacion-mobile.svg'
import notaryIcon from '../../../assets/liberacion/icon-notaria.svg'
import notaryMobileIcon from '../../../assets/liberacion/icon-notaria-mobile.svg'
import letterIcon from '../../../assets/liberacion/icon-carta.svg'
import letterMobileIcon from '../../../assets/liberacion/icon-carta-mobile.svg'
const documents = [
  { icon: quoteIcon, mobileIcon: quoteMobileIcon, text: 'Cotización de gastos notariales' },
  {
    icon: notaryIcon,
    mobileIcon: notaryMobileIcon,
    text: 'Datos de la notaría seleccionada (nombre del notario, contacto y ubicación)'
  },
  {
    icon: letterIcon,
    mobileIcon: letterMobileIcon,
    text: 'Carta de instrucciones de cancelación de hipoteca (emitida por HIR Casa)'
  }
]
const items = documents.map((item, index) => ({
  id: String(index),
  text: item.text,
  iconSrc: item.icon,
  mobileIconSrc: item.mobileIcon
}))
</script>
<style scoped>
.release-documentation-note {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: var(--ds-purple-400);
}
</style>
